
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/constants';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HomeService } from 'src/app/service/home.service';
import { DatePipe } from '@angular/common'
import { FormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-add-home',
  templateUrl: './add-home.component.html',
  styleUrls: ['./add-home.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None 
})
export class AddHomeComponent implements OnInit {
  loadNumber
  expDate
  routeDate
  route
  run
  mileage
  costCentre
  allocationRate
  totalCost
  domicile
  reasonId
  carrier
  eventType: string;
  heading: any;
  errormsg: string;
  castCenterDropDown;
  domicileDropDown;
  routeDropDown = [];
  reasonIdDropDown;
  carrierDropDown;
  routeId: any;
  response: any;
  previosCostCentre: any;
  domicileFilterCtrl = new FormControl();
  filteredDomiciles: ReplaySubject<any[]> = new ReplaySubject(1);
  routeFilterCtrl = new FormControl();
  filteredRoutes: ReplaySubject<any[]> = new ReplaySubject(1);
  costCentreFilterCtrl = new FormControl();
  filteredCostCentres: ReplaySubject<any[]> = new ReplaySubject(1);
  reasonIdFilterCtrl = new FormControl();
  filteredReasonIds: ReplaySubject<any[]> = new ReplaySubject(1);
  carrierFilterCtrl = new FormControl();
  filteredCarriers: ReplaySubject<any[]> = new ReplaySubject(1);
  constructor(public dialogRef: MatDialogRef<AddHomeComponent>, private readonly constants: Constants, private readonly homeService: HomeService,
    @Inject(MAT_DIALOG_DATA) public dataStore: any, public readonly datepipe: DatePipe, private readonly ngxUiLoaderService: NgxUiLoaderService) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType
    this.domicileDropDown = this.dataStore.domicileDrpDwn
    this.reasonIdDropDown = this.dataStore.reasonIdDrpDwn
    this.castCenterDropDown = this.dataStore.costCentreDrpDown
    this.carrierDropDown = this.dataStore.carrierDropDown
    this.filteredDomiciles.next(this.domicileDropDown);
    this.filteredReasonIds.next(this.reasonIdDropDown);
    this.filteredCostCentres.next(this.castCenterDropDown);

    this.filteredCarriers.next(this.carrierDropDown);

    this.carrierFilterCtrl.valueChanges.pipe(
      startWith(''),
      map(search => search ? this._filterCarrier(search) : this.carrierDropDown)
    ).subscribe(filtered => {
      this.filteredCarriers.next(filtered);
    });


    this.domicileFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => search ? this._filter(search) : this.domicileDropDown)
      )
      .subscribe(filtered => {
        this.filteredDomiciles.next(filtered);
      });
    this.routeFilterCtrl.valueChanges.pipe(
      startWith(''),
      map(search => search ? this._filterRoute(search) : this.routeDropDown)
    ).subscribe(filtered => {
      this.filteredRoutes.next(filtered);
    });

    this.filteredCostCentres.next(this.castCenterDropDown);

    this.costCentreFilterCtrl.valueChanges.pipe(
      startWith(''),
      map(search => search ? this._filterCostCentre(search) : this.castCenterDropDown)
    ).subscribe(filtered => {
      this.filteredCostCentres.next(filtered);
    });


    this.reasonIdFilterCtrl.valueChanges.pipe(
      startWith(''),
      map(search => search ? this._filterReasonId(search) : this.reasonIdDropDown)
    ).subscribe(filtered => {
      this.filteredReasonIds.next(filtered);
    });


    if (this.eventType ==='EDIT') {
      this.domicile = this.domicileDropDown?.find(x => x.label == this.dataStore.domicile) // NOSONAR
      this.domicileListChange();
      this.totalCost = this.dataStore.totalCost
      this.loadNumber = this.dataStore.loadNumber
      this.expDate = this.datepipe.transform(this.dataStore.expDate, 'yyyy-MM-dd');
      this.routeDate = this.datepipe.transform(this.dataStore.routeDate, 'yyyy-MM-dd');
      this.run = this.dataStore.run
      this.mileage = this.dataStore.mileage
      this.costCentre = this.castCenterDropDown?.find(x => x.label == this.dataStore.costCentre) // NOSONAR
      this.previosCostCentre = this.dataStore.costCentre
      this.allocationRate = this.dataStore.allocationRate
      this.reasonId = this.reasonIdDropDown?.find(x => x.label == this.dataStore.reasonId) // NOSONAR
      this.carrier = this.carrierDropDown?.find(x => x.label == this.dataStore.carrier) // NOSONAR
      this.routeId = this.dataStore.routeId
    }

  }

  private _filter(search: string): any[] {
    return this.domicileDropDown.filter(option =>
      option.label.toLowerCase().includes(search.toLowerCase()));
  }

  private _filterRoute(search: string): any[] {
    return this.routeDropDown.filter(option =>
      option.label.toLowerCase().includes(search.toLowerCase()));
  }

  private _filterCostCentre(search: string): any[] {
    return this.castCenterDropDown.filter(option =>
      option.label.toLowerCase().includes(search.toLowerCase()));
  }

  private _filterReasonId(search: string): any[] {
    return this.reasonIdDropDown.filter(option =>
      option.label.toLowerCase().includes(search.toLowerCase()));
  }

  private _filterCarrier(search: string): any[] {
    return this.carrierDropDown.filter(option =>
      option.label.toLowerCase().includes(search.toLowerCase()));
  }


  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.value == o2.value : o1 == o2; // NOSONAR
  }


  validate(event: any, module) {
    const t = event.target.value;
    if (module == "value") { // NOSONAR
      event.target.value =
        t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 3) : t;
    }
  }
  keyPressAlphaNumeric(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (/[.0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  showError(message) {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTimeShort);
  }

  domicileListChange() {
    this.routeDropDown = [];
    this.homeService.getRouteByDomicile(this.domicile?.value).subscribe(
      response => {
        response.forEach(element => {
          this.routeDropDown.push({ label: element, value: element })
        });
        if (this.eventType == "EDIT") { this.route = this.routeDropDown?.find(x => x.label == this.dataStore?.route) } // NOSONAR
        this.filteredRoutes.next(this.routeDropDown);
      }

    )
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null) // NOSONAR
    {
      return true;
    }
    return false;
  }

  public saveClick() {
    this.errormsg = "";
    if (this.isValueOk(this.loadNumber)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.carrier)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.expDate)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.route?.value)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.mileage)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.allocationRate)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.domicile)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.costCentre)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.reasonId)) {
      this.showError(this.constants.formInputError);
    } else if (this.totalCost?.toString().split(".").length > 2) {
      this.showError("invalid decimal");
    } else if (Number(this.mileage) <= 0) {
      this.showError("Mileage Must Be Greater Than Zero");
    } else if (Number(this.allocationRate) <= 0) {
      this.showError("Allocation Rate Must Be Greater Than Zero");
    } else if (Number(this.allocationRate) != 1 && this.eventType == "ADD") { // NOSONAR
      this.showError("Load Number / Expedite Date Allocation Does Not Equal One");
    } else {
      this.saveAPICall();
    }
  }

  saveAPICall() {
    this.errormsg = ""
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    const updateObject = {
      loadNumber: this.loadNumber.toString(),
      expediteDate: this.datepipe.transform(this.expDate, 'MM-dd-yyyy'),
      routeDate: this.datepipe.transform(this.routeDate, 'MM-dd-yyyy'),
      route: this.route.value,
      run: this.run,
      mileage: this.mileage.toString(),
      costCentre: this.costCentre.label,
      allocationRate: this.allocationRate.toString(),
      totalCost: this.totalCost == "" ? null : Number(this.totalCost?.toString().includes('.') ? this.totalCost?.toString().split(".")[0] + "." + this.totalCost?.toString().split(".")[1]?.substring(0, 2) : this.totalCost), // NOSONAR
      domicile: this.domicile.label,
      reasonId: this.reasonId.label.toString(),
      carrier: this.carrier.label,
      routeId: this.routeId
    }
    if (this.eventType == "ADD") { // NOSONAR
      this.homeService.addEboiHome(updateObject).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.response = JSON.parse(response)
          if (this.response[0]?.message == "SUCCESS") { // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
              resmsg: this.routeDatecheck()
            });
          } else {
            this.showError(this.response[0].message);
          }
        }, error => {
          this.showError(this.constants.APIErrorMessage);

        });

    }
    else if (this.eventType == "EDIT") { // NOSONAR
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)

      this.homeService.updateEboiHome(updateObject, this.previosCostCentre).subscribe(
        response => {
          this.response = JSON.parse(response)
          if (this.response[0].message == "SUCCESS") { // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
              resmsg: this.routeDatecheck()
            });
          } else {
            this.showError(this.response[0].message ? this.response[0].message : this.constants.APIErrorMessage);
          }

        }, error => {
          console.info(error)
          this.showError(this.constants.APIErrorMessage);
        });
    }

  }

  routeDatecheck() {
    if (this.routeDate > this.expDate)
    {
      return "warning-msg";
    }
    else
    {
      return "continue";
    }
  }

  ifNullSetZero(param) {
    return Number(param ? param : 0);
  }

  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }

  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }

}
